@if (projectMatch?.project && projectDisplayMode() == ProjectDescriptorUse.BETA_READER_VIEW_OF_PROJECT) {
  <span >
    <div class="flex flex-col md:flex-row items-center p-3 w-full">
      <img height="64px" [src]="'assets/book_image_placeholder.png'" [alt]="projectMatch.project.title" class="my-4 md:my-0 shadow-2 mr-5"/>
      <div class="flex-1 flex flex-col items-center text-center md:text-left">
        <div class="font-bold text-2xl">{{projectMatch.project.title}}</div>
        <div class="mb-2">{{projectMatch.project.summary}}</div>
        <p-rating [readonly]="true" [cancel]="false" styleClass="mb-2" />
        <div class="flex items-center mt-2">
          @for (category of projectMatch.project.profileGroup.profileSelections | slice:0:3; track category) {
            <span>
              @if (Utils.isArray(category.value)) {
                <span>
                  @for (tag of category.value | slice:0:1; track tag) {
                    <span>
                      <i [class]="'pi mr-2 '+tag.icon"></i>
                      <span class="font-semibold">{{tag.value}}</span>
                    </span>
                  }
                </span>
              }
            </span>
          }
        </div>
      </div>
      <div class="flex flex-row md:flex-col justify-between w-full md:w-auto items-center md:align-items-end mt-5 md:mt-0">
        <span class="text-2xl font-semibold mb-2 align-self-center md:align-self-end">{{projectMatch.author}}</span>
        @if ((!projectMatch.projectMatchStatus || projectMatch.projectMatchStatus === ProjectMatchStatus.ACTIVE)) {
          <span [class]="'project-badge status-' + projectMatch.projectMatchStatus.toLowerCase()">{{projectMatch.projectMatchStatus}}</span>
          <span>
            @if (!showDetail) {
              <p-button [raised]="true" icon="pi pi-info-circle" label="See More" (click)="showDetail=true" styleClass="mb-2 p-button-sm" />
            }
            @if (showDetail) {
              <p-button icon="pi pi-info-circle" label="Close Detail" (click)="showDetail=false" styleClass="mb-2 p-button-sm" />
            }
          </span>
        }
        @if (!projectMatch.projectMatchStatus) {
          <span [class]="'project-badge status-' + projectMatch.projectMatchStatus.toLowerCase()">{{projectMatch.projectMatchStatus}}</span>
          
        }
        @if (projectMatch.projectMatchStatus && projectMatch.projectMatchStatus != ProjectMatchStatus.ACTIVE) {
          <span [class]="'project-badge status-' + projectMatch.projectMatchStatus.toLowerCase()">{{projectMatch.projectMatchStatus}}</span>
          <span>
            @if (!showDetail) {
              <p-button [raised]="true" icon="pi pi-info-circle" label="See More" (click)="showDetail=true" styleClass="mb-2 p-button-sm" />
            }
            @if (showDetail) {
              <p-button icon="pi pi-info-circle" label="Close Detail" (click)="showDetail=false" styleClass="mb-2 p-button-sm" />
            }
          </span>
        }
      </div>
    </div>
    <hr/>
    @if (showDetail) {
      <project-detail [projectMatch]="projectMatch" />
    }
  </span>
}
@if (projectDisplayMode() == ProjectDescriptorUse.WRITER_PROJECT) {
  <span >
    <h1>ERROR - Please Report: Please use Project-Profile-Component for Writer View of Project</h1>
  </span>
}
